module.exports = __webpack_public_path__ + "static/media/sleepTrackerApp-min.7288c4e5.png";